const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "dashboard-alt-3",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "secondary",
    x: 3,
    y: 3,
    width: 18,
    height: 14,
    rx: 1,
    style: {
      fill: "rgb(44, 169, 188)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M10,14a2,2,0,0,1,4,0",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M17,7l-3.84,5.37M21,16V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V16a1,1,0,0,0,1,1H20A1,1,0,0,0,21,16Zm-7,5H10l1-4h2ZM8,21h8",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2c0afe55e42fa65f022a3374c20e6335.svg";
export { ForwardRef as ReactComponent };